import * as React from 'react'

const SvgHelpFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 14.375a.938.938 0 110-1.875.938.938 0 010 1.875zm.713-4.844v1.563H9.306V9.375h1.319a1.487 1.487 0 000-2.969h-.938c-.819 0-1.484.662-1.487 1.482v.4H6.806v-.4A2.894 2.894 0 019.7 5h.925a2.894 2.894 0 01.075 5.781h.013z"
      fill="#163250"
    />
  </svg>
)

export default SvgHelpFilledIcon
